/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: null,
    name: 'Parkirna mesta',
    submenu: [
      {
        url: '/charts/parking/shortterm',
        name: 'Kratkotrajno',
        slug: 'charts-parking-shortterm'
      },
      {
        url: '/charts/parking/longterm',
        name: 'Dolgotrajno',
        slug: 'charts-parking-longterm'
      }
      // {
      //   url: "/charts/parking/owner",
      //   name: "Lastniki",
      //   slug: "charts-parking-owner",
      // },
      /*{
        url: "/charts/parking/rent",
        name: "Najemniki",
        slug: "charts-parking-rent",
      },
      {
        url: "/charts/parking/owner",
        name: "Lastniki",
        slug: "charts-parking-owner",
      },
      {
        url: "/charts/parking/valuecards",
        name: "Polnitev kartic",
        slug: "charts-validity-cards",
      },
      {
        url: "/charts/parking/owner/credit",
        name: "Dobropisi lastnikov",
        slug: "charts-office-rent",
      },*/
    ]
  },
  /*{
    url: null,
    name: "Poslovni prostori",
    submenu: [
      {
        url: "/charts/office/rent",
        name: "Najem",
        slug: "charts-office-rent",
      },
    ]
  },*/

  {
    url: '/upload/file',
    name: 'Dodaj datoteko',
    slug: 'upload-file'
  },
  {
    url: '/fileList',
    name: 'Seznam datotek',
    slug: 'file-list'
  }


  // {
  //   url: "/charts/cashregisters",
  //   name: "Promet na blagajnah",
  //   slug: "charts-cash-register",
  // },
  // {
  //   url: "/charts/articles",
  //   name: "Promet po artiklih v EUR",
  //   slug: "charts-per-articles",
  // },
  // {
  //   url: "/charts/valuecards",
  //   name: "Polnitve vrednostnih kartic",
  //   slug: "charts-value-cards",
  // },
  // {
  //   url: "/charts/costandearnings",
  //   name: "Stroški/Zaslužki",
  //   slug: "charts-costs-earnings",
  // },
  // {
  //   url: "/charts/parking/shortterm",
  //   name: "Kratkotrajno parkiranje",
  //   slug: "charts-parking-short-term",
  // },
  // {
  //   url: "/charts/parking/longterm",
  //   name: "Dolgotrajno parkiranje",
  //   slug: "charts-parking-long-term",
  // },
  // {
  //   url: "/charts/contracts",
  //   name: "Pogodbe",
  //   slug: "charts-contracts",
  // },
  // {
  //   url: "/charts/validitycards",
  //   name: "Validacijske kartice",
  //   slug: "charts-validity-cards",
  // },
]
